import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Component,
  Inject,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import FileSaver from 'file-saver';
import { LoadingService } from 'src/app/services/loading.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import {
  of,
  map,
  Observable,
  forkJoin,
  switchMap,
  catchError,
  from,
} from 'rxjs';
import { fetchAuthSession } from '@aws-amplify/auth';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.css'],
})
export class UploadFilesComponent implements OnInit {
  s3ServiceRoute: any = `${environment.salesApi}/api/v1`;
  @Input() numberOS: any;

  successDelete: boolean = false;
  loadingDelete: boolean = false;
  errorDelete: string | null = null;

  successCreate: boolean = false;
  loadingCreate: boolean = false;
  errorCreate: string | null = null;

  successGet: boolean = false;
  loadingGet: boolean = true;
  errorGet: string | null = null;

  multimediaBase: any = [];
  multimedia: any = [];

  pdfViewer: any = false;
  index: any;
  url: any;
  @Input() confirmAllDelete: boolean = false;
  @Input() confirmGuardar: boolean = false;
  @Output() isloadingGet = new EventEmitter<boolean>();
  @Output() isloadingMutations = new EventEmitter<boolean>();

  constructor(
    private sanitizer: DomSanitizer,
    public loadingService: LoadingService,
    private http: HttpClient,
    public dialogRef: MatDialogRef<UploadFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.getAllMultimedia();
  }

  private async getAuthHeaders(): Promise<HttpHeaders> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      if (token) {
        return new HttpHeaders({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        });
      } else {
        console.warn('⚠️ No hay token disponible para autenticación');
        return new HttpHeaders({
          'Content-Type': 'application/json',
        });
      }
    } catch (error) {
      console.error('❌ Error obteniendo token para headers:', error);
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
  }

  async getAllMultimedia() {
    const headers = await this.getAuthHeaders();
    this.isloadingGet.emit(true);

    this.http
      .get<any[]>(`${this.s3ServiceRoute}/getFilesNumberOS/${this.numberOS}`, {
        headers,
      })
      .pipe(
        switchMap((list: any[]): Observable<any[]> => {
          if (!list || list.length === 0) {
            this.isloadingGet.emit(false);
            this.successGet = true;
            return of([]); // no hay archivos
          }

          const detailRequests: Observable<any>[] = list.map((el: any) =>
            this.http
              .get(`${this.s3ServiceRoute}/getFileAnulacionOS/${el.Key}`, {
                headers,
              })
              .pipe(
                map((res: any) => ({ ok: true, key: el.Key, data: res })),
                catchError((err) => of({ ok: false, key: el.Key, error: err }))
              )
          );

          return forkJoin(detailRequests);
        })
      )
      .subscribe({
        next: (results: any[]) => {
          results.forEach((item) => {
            if (!item.ok) {
              console.error(
                ` Error al obtener archivo ${item.key}`,
                item.error
              );
              return;
            }

            const bytes = new Uint8Array(item.data.data);

            const binary = new TextDecoder().decode(bytes);

            const split = item.key.split(';').pop();
            const nameDownload = split.split('.')[0];
            const html = this.extractHtmlFromEml(binary);
            const image = {
              src: binary,
              key: item.key,
              name: split,
              nameDownload,
              htmlContent: html,
              type: html ? 'eml' : 'otro',
            };

            this.multimedia.push(image);
          });

          this.multimediaBase = [...this.multimedia];

          this.successGet = true;
          this.isloadingGet.emit(false);
        },
        error: (error) => {
          console.error('Error al obtener multimedia:', error);
          this.errorGet = error;
          this.isloadingGet.emit(false);
        },
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['confirmGuardar']) {
      this.defineMultimediaActions();
    }

    if (changes['confirmAllDelete']) {
      this.deleteAllMultimedia();
    }
  }

  deleteAllMultimedia() {
    forkJoin(this.deleteMultimediaS3(this.multimediaBase)).subscribe({
      next: () => {},

      complete: () => {
        this.loadingDelete = false;
        this.successDelete = true;
        this.isloadingMutations.emit(false);
      },

      error: (err) => {
        this.loadingDelete = false;
        this.successDelete = false;
        this.errorDelete = err;

        this.isloadingMutations.emit(false);
      },
    });
  }

  defineMultimediaActions() {
    this.isloadingMutations.emit(true);

    const toADD = this.multimedia.filter(
      (el: any) =>
        !this.multimediaBase.find((base: any) => base.name === el.name)
    );

    const toDELETE = this.multimediaBase.filter(
      (el: any) => !this.multimedia.find((base: any) => base.name === el.name)
    );

    const operations = [];

    if (toADD.length > 0) {
      this.loadingCreate = true;
      operations.push(this.sendMultimediatoS3(toADD));
    }

    if (toDELETE.length > 0) {
      this.loadingDelete = true;
      operations.push(this.deleteMultimediaS3(toDELETE));
    }

    if (operations.length === 0) {
      this.isloadingMutations.emit(false);
      return;
    }

    forkJoin(operations).subscribe({
      next: () => {},

      complete: () => {
        this.loadingCreate = false;
        this.loadingDelete = false;

        this.successCreate = true;
        this.successDelete = true;

        this.isloadingMutations.emit(false);
      },

      error: (err) => {
        this.loadingCreate = false;
        this.loadingDelete = false;

        this.successCreate = false;
        this.successDelete = false;

        this.errorCreate = err;
        this.errorDelete = err;

        this.isloadingMutations.emit(false);
      },
    });
  }
  extractHtmlFromEml(emlText: string): string | null {
    const base64Prefix = 'data:message/rfc822;base64,';
    if (!emlText.startsWith(base64Prefix)) {
      console.warn('El EML no viene en formato data URI');
      return null;
    }

    const base64Content = emlText.replace(base64Prefix, '');

    const decoded = atob(base64Content);

    const match = decoded.match(
      /Content-Type:\s*text\/html[\s\S]*?<html([\s\S]*?)<\/html>/i
    );

    if (!match) {
      console.warn('No se encontró HTML en el EML');
      return null;
    }

    return `<html ${match[1]}</html>`;
  }

  getBase64 = (file: any, cb: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  onFileSelected(event: any) {
    if (event.target.files) {
      // let base64 = '';

      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];

        const allowedTypes = [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'image/jpeg',
          'image/png',
          'message/rfc822',
          'application/octet-stream',
        ];

        const fileExt = file.name.split('.').pop().toLowerCase();
        const allowedExtensions = [
          'pdf',
          'doc',
          'docx',
          'xls',
          'xlsx',
          'jpg',
          'jpeg',
          'png',
          'eml',
        ];

        if (
          allowedTypes.includes(file.type) ||
          allowedExtensions.includes(fileExt)
        ) {
          this.getBase64(file, (result: any) => {
            const image = {
              src: result,
              name: file.name,
              nameDownload: file.name,
            };

            this.multimedia.push(image);
            // });
          });
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Error al subir',
            text: `Este formato no está soportado: ${file.name}`,
            showConfirmButton: false,
            timer: 4000,
          });
        }
      }
    }
  }

  sendMultimediatoS3(multimediaToSend: any[]) {
    return from(this.getAuthHeaders()).pipe(
      switchMap((headers) => {
        const requests = multimediaToSend.map((el: any) =>
          this.http.post(
            `${this.s3ServiceRoute}/addFileAnulacionOS`,
            {
              data: el.src,
              numberOS: this.numberOS,
              fileName: el.name,
            },
            { headers }
          )
        );

        return forkJoin(requests); // ahora sí está bien
      })
    );
  }

  downloadFile(multimedia: any) {
    const split = multimedia.src.split(',');
    const type = split[0];
    const binary = split[1];

    const byteCharacters = atob(binary);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: type });
    FileSaver.saveAs(blob, multimedia.name);
  }

  deleteMultimediaLocal(el: any, i: any) {
    this.multimedia.splice(i, 1);
  }
  deleteMultimediaS3(multimediaToDelete: any[]) {
    return from(this.getAuthHeaders()).pipe(
      switchMap((headers) => {
        const requests = multimediaToDelete
          .filter((m) => m.key)
          .map((el: any) =>
            this.http.delete(
              `${this.s3ServiceRoute}/deleteFileAnulacionOS/${el.key}`,
              { headers }
            )
          );

        return forkJoin(requests);
      })
    );
  }

  activatePDF(multimedia: any, index: any) {
    if (index === this.index) {
      this.pdfViewer = false;
      this.index = null;
      return;
    }

    this.index = index;

    if (multimedia.type === 'eml' && multimedia.htmlContent) {
      this.url = null;
      this.pdfViewer = true;
    } else {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(multimedia.src);
      this.pdfViewer = true;
    }
  }
}
